// extracted by mini-css-extract-plugin
export var alertIcon = "_pu-0";